"use client";

import { Scale } from "@/animations/scale";
import Image from "@/components/Image";
import { cn } from "@/utils";
import { formatNumber } from "@/utils/number-format";
import { useResize } from "@/utils/useResize";
import { cva } from "class-variance-authority";
import clsx from "clsx";
import { useMemo, useState } from "react";
import { useDeFuture } from "../apis/defurures";
import { HeaderFinder } from "./header-finder";
import { WrapperFinder } from "./wrapper-finder";
import { ModalDefuture } from "../Menu/modals/ModalDefuture";

const variants = cva("w-full", {
  variants: {
    twSize: {
      xs: "max-w-[80%] ml-[14px] mt-[32px]",
      sm: "max-w-[80%] ml-[14px] mt-[32px]",
      md: "max-w-[80%] ml-[14px] mt-[32px]",
      lg: "max-w-[555px] ml-[32px] mt-[32px]",
      xl: "max-w-[511px] ml-[50px] -mt-[177px]",
      "2xl": "max-w-[543px] ml-[53px] -mt-[188px]",
      "3xl": "max-w-[575px] ml-[57px] -mt-[200px]",
    },
  },
  defaultVariants: {
    twSize: "2xl",
  },
});

export function FinderDeFutures() {
  const { twSize, width } = useResize();

  const { data } = useDeFuture();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const total_fee = useMemo(() => {
    const value = data?.data?.total_fee;
    if (!value) {
      return "--";
    }
    const temp = formatNumber(Number(value));

    let txt: string = `${temp.value}`;

    if (String(temp.value2).charAt(0) !== "0") {
      txt = `${txt}.${String(temp.value2).charAt(0)}`;
    }
    txt = `${txt}${temp.text ? temp.text + "+" : ""}`;

    return `${txt}`;
  }, [data?.data]);

  const trading_volume = useMemo(() => {
    const value = data?.data?.trading_volume;
    if (!value) {
      return "--";
    }
    const n = value.endsWith("B") ? parseFloat(value) * 1_000_000_000 : value;
    const temp = formatNumber(Number(n));
    let txt: string = `${temp.value}`;

    if (String(temp.value2).charAt(0) !== "0") {
      txt = `${txt}.${String(temp.value2).charAt(0)}`;
    }
    txt = `${txt}${temp.text ? temp.text + "+" : ""}`;

    return `${txt}`;
  }, [data?.data]);

  return (
    <>
      <Scale>
        <WrapperFinder className={cn(variants({ twSize: twSize }))}>
          <HeaderFinder>
            <p className="text-[#23262F] text-center text-[13px] font-medium leading-4 truncate">
              Holdstation DeFutures
            </p>
          </HeaderFinder>

          <div className="bg-[#040506] rounded-b-2xl">
            <div
              className=""
              style={{
                backgroundImage:
                  width >= 768
                    ? `url(${require("@/assets/bg/bg_defutures.png")})`
                    : `url(${require("@/assets/bg/bg_defutures_mobile.png")})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right bottom",
                backgroundColor: "#040506",
                backgroundSize: "cover",
              }}
            >
              <div className="p-5">
                <p className="text-xl lg:text-[1.75rem] lg:leading-[2.5rem] font-medium text-[#E6E8EC]">
                  <span className="text-[#E6E8EC]">
                    A perpetual DEX on ZKsync designed for up to
                  </span>{" "}
                  <span className="text-[#11E780]">500x leverage</span> trading
                  with a CEX-like experience.
                </p>
              </div>

              <div className="flex flex-col gap-3 lg:gap-10 px-5 py-5 mt-[80px] md:mt-[106px]">
                <div className="flex flex-col gap-1 lg:gap-0">
                  <p className="text-[1.625rem] lg:text-[2.5rem] lg:leading-[3rem] font-medium text-[#12AD62]">
                    ${total_fee}
                  </p>
                  <p className="text-sm lg:text-base font-medium text-[#E6E8EC]">
                    Total Fee Collected
                  </p>
                </div>

                <div className="flex flex-col gap-1 lg:gap-0">
                  <p className="text-[1.625rem] lg:text-[2.5rem] lg:leading-[3rem] font-medium text-[#12AD62]">
                    ${trading_volume}
                  </p>
                  <p className="text-sm lg:text-base font-medium text-[#E6E8EC]">
                    Total Trading Volume
                  </p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-[40px_1fr_112px] lg:grid-cols-[48px_1fr_112px] gap-2.5 lg:gap-4 p-4 bg-[#070809] backdrop-blur-[12.5px] border-t border-t-white/10 rounded-b-2xl">
              <div className="w-10 h-10 lg:w-12 lg:h-12 rounded-xl flex-shrink-0">
                <Image
                  src={require("@/assets/icons/ic_defutures.png")}
                  width={512}
                  height={512}
                  alt="DeFutures"
                />
              </div>

              <div className="flex flex-col justify-center">
                <p className="text-sm font-medium text-white line-clamp-1">
                  Holdstation DeFutures
                </p>
                <p className="text-sm font-medium text-[#777E90] line-clamp-1">
                  Leading perpeptual DEX on ZKsync
                </p>
              </div>
              <div className="flex items-center justify-end">
                <button
                  // target="_blank"
                  // href={"https://holdstation.exchange"}
                  type="button"
                  className={clsx(
                    "px-6 py-2.5 rounded-full bg-white",
                    "text-sm text-[#141416] font-medium whitespace-nowrap"
                  )}
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  View More
                </button>
              </div>
            </div>
          </div>
        </WrapperFinder>
      </Scale>
      {isOpen ? (
        <ModalDefuture
          onClose={() => {
            setIsOpen(false);
          }}
        />
      ) : null}
    </>
  );
}
